import React from 'react';


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import { ArrowLeft, ArrowRight } from '../kit/icons';
import { Heading } from '../kit/Heading';

const MySlider = ({ data, mainColor }) => {
  const slides = data.sectionSlider.slideArray
  const fullBG = data.sectionSlider.fullBG

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    useTransform: false,
    nextArrow: <ArrowRight width='96px' height="96px" fill={mainColor} />,
    prevArrow: <ArrowLeft width='96px' height="96px" fill={mainColor} />
  };



  const printContent = (s, i) => {
    return <div className="">
      <div><Heading data={s.heading} />
        <p key={"slidep" + i} className="mb-4 text-2xl">
          {s.text.map((block) => (
            <span key={block._key}>
              {block.children.map((child) => child.text).join(' ')}
            </span>
          ))}
        </p>
      </div>
    </div>
  }

  const fullBGSlider = () => <div className="" style={{ zIndex: 10, }}>
    <Slider {...sliderSettings}>
      {slides.map((s, i) => <div key={"currentIndexSlide" + i} >
        <div className='w-full' style={{
          backgroundPosition: "center",
          backgroundSize: "cover",
          height: "700px", backgroundImage: `url(${s.image?.image?.asset?.url})`
        }}>
          <div className='container h-full mx-auto flex  items-end pb-16'>
            <div className='w-2/3 pb-8 px-8' style={{ background: "rgba(0,0,0,0.52)", color: "#FFFFFF" }}>
              {printContent(s, i)}
            </div>
          </div>

        </div>
      </div>
      )}
    </Slider >
  </div >

  const slider = () => <div className="p-16" style={{ display: "block", zIndex: 10 }}>
    <Slider {...sliderSettings}>
      {slides.map((s, i) => <div key={"currentIndexSlide" + i} ><div className={"container mx-auto px-5 flex"} >
        {printContent(s, i)}
        <div className="w-1/2" >
          <img src={s.image?.image?.asset?.url} alt={s.image?.image?.title} className="object-cover w-full h-full shadow-lg" style={{ height: "500px" }} />
        </div>
      </div>
      </div>
      )}
    </Slider >
  </div >

  return !fullBG ? fullBGSlider() : slider()

};

export default MySlider;